import { t } from 'i18next';
import { PowerButtonContainer, PowerButtonVentilation } from '../styles';
import { PowerButtonProps } from '../types';
import { PowerRCIcon } from '~/icons/PowerRC';
import { colors } from '~/styles/remoteControlColors';

export function PowerButton({ onClickModality, loading }: Readonly<PowerButtonProps>) {
  function onClick(): void {
    if (!loading) {
      onClickModality();
    }
  }
  return (
    <PowerButtonVentilation
      type="button"
      onClick={onClick}
      loading={loading}
      data-testid="controle_inteligente-tag-desligar_maquina-modo_ventilar"
    >
      <PowerButtonContainer>
        <PowerRCIcon color={colors.Red600} />
        {t('desligarMaquina')}
      </PowerButtonContainer>
    </PowerButtonVentilation>
  );
}
